export const FABRIC_URL_PARSER_GATE = 'fabric_url_parser';
